import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DefaultPageSize } from '../../../core/dto/defaultPage.size';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { AppUtils } from '../../../core/config/app.utils';
import { Pagination } from '../../../core/dto/pagination';
import { CustomerService } from '../../../core/services/customer.service';
import { ItineraryService } from '../../../core/services/itinerary.service';
import { SETTINGS } from "../../../core/config/common.settings";
import { TranslocoService } from "@ngneat/transloco";

@Component({
  selector: 'app-view-status-log',
  templateUrl: './view-status-log.component.html',
  styleUrls: ['./view-status-log.component.scss'],
})
export class ViewStatusLogComponent implements OnInit {
  rId: any;
  pageSize = new DefaultPageSize();
  sortField: any;
  sortOrder: any;
  allCustomers: any;
  cardLoading = true;
  sortColumn = {
    compareDate: (a: any, b: any) => {
      return (new Date(a.createdAt) as any) - (new Date(b.createdAt) as any);
    },
    compareName: (a: any, b: any) => a.name.localeCompare(b.name),
  };
  tourRef: any;

  constructor(
    private route: ActivatedRoute,
    private itineraryService: ItineraryService,
    private translocoService: TranslocoService,
  ) {}

  ngOnInit(): void {
    this.rId = this.route.snapshot.paramMap.get('id');
    this.tourRef = this.route.snapshot.paramMap.get('tour');
  }

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;

    const currentSort = params.sort.find(item => item.value !== null);
    this.sortField = (currentSort && currentSort.key) || null;
    this.sortOrder =
      (currentSort && AppUtils.getSortOrder(currentSort.value)) || null;
    this.getStatusLogs();
  }

  getStatusLogs(): void {
    this.cardLoading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      itinerary: this.rId,
      sortOrder: this.sortOrder,
    });

    this.itineraryService.getPagedStatusLog(payload).then(res => {
      this.allCustomers = res.data;
      this.pageSize.length = res.metadata[0]?.total;
      this.cardLoading = false;
    });
  }

  getStatusKey(status: string): string {
    switch (status) {
      case SETTINGS.ITINERARY_STATUSES.DRAFT:
        return this.translocoService.translate("itineraries.list.statuses.draft");
      case SETTINGS.ITINERARY_STATUSES.SENT:
        return this.translocoService.translate("itineraries.list.statuses.sent");
      case SETTINGS.ITINERARY_STATUSES.FOLLOW_UP:
        return this.translocoService.translate("itineraries.list.statuses.followUp");
      case SETTINGS.ITINERARY_STATUSES.CONFIRMED:
        return this.translocoService.translate("itineraries.list.statuses.confirm");
      case SETTINGS.ITINERARY_STATUSES.INVOICE_SENT:
        return this.translocoService.translate("itineraries.list.statuses.invoiceSent");
      case SETTINGS.ITINERARY_STATUSES.PAID:
        return this.translocoService.translate("itineraries.list.statuses.paid");
      case SETTINGS.ITINERARY_STATUSES.LOST:
        return this.translocoService.translate("itineraries.list.statuses.lost");
      case SETTINGS.ITINERARY_STATUSES.CANCELLED:
        return this.translocoService.translate("itineraries.list.statuses.cancel");
      default:
        return status;
    }
  }
}
